import { Loader, loaderStylesSpinnerXLarge } from '@h2oai/ui-kit';
import { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';

import { Error403Page } from '../../ErrorPage';

interface RequireAuthProps {
  children: ReactNode;
}

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const auth = useAuth();

  if (auth.isLoading || auth.activeNavigator) {
    return <Loader styles={loaderStylesSpinnerXLarge} label="Loading..." />;
  }

  if (!auth.isAuthenticated) return <Error403Page />;

  return <>{children}</>;
};
